export default __webpack_public_path__ + "static/media/recent-clock.28319874.svg";